import type { Components, Theme } from '@mui/material';

export const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    input: () => ({
      fontSize: '1.4rem',
      '&.MuiOutlinedInput-input': {
        padding: '8px 12px',
      },
    }),
  },
};
